var map = {
	"./Bronze.svg": 864,
	"./Diamond.svg": 865,
	"./Gold.svg": 866,
	"./Silver.svg": 867,
	"./company-default.png": 154,
	"./dummy.jpg": 213,
	"./dummy_profile.jpg": 98,
	"./icons8-whatsapp.svg": 79,
	"./invoice-sign": 253,
	"./invoice-sign.js": 253,
	"./videoimg.png": 265
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 174;